/* eslint-disable import/no-namespace */
import axios from 'axios'
import { URL } from '../../config'
import { getRequest, postRequest } from '../../utils/functions/httpRequest'
import { types } from './'

// define URLS
const centerURL = URL.center
const memberURL = URL.member
const  eventURL = URL.event
const seasonURL = URL.season

// const formname = 'eventinfo'

// Event types raised by this action
export function setCenter(center,name,certnumber)
{
	const centerinfo = {
		center,
		name,
		certnumber,
	}
	return {
		type: types.Event.SET_CENTER,
		payload: centerinfo,
	}
}
export function resetEventWizard()
{
	return {
		type: types.Event.RESET_EVENT_WIZARD
	}
}
export function resetEventState()
{
	return {
		type: types.Event.RESET_EVENT_STATE
	}
}
export function resetWizardState(currentStep)
{
	return {
		type: types.Event.RESET_WIZARD_STATE,
		payload:currentStep,
	}
}
export function setSearchMode(searchMode)
{
	return (dispatch) =>
	{
		dispatch(setSearchModeSuccess(searchMode))
	}		
}
export function setSearchModeSuccess(searchMode)
{	
	return {
		type:  types.Event.SET_SEARCH_MODE,
		payload: searchMode,
	}
}
export function resetEventDirector()
{

}
export function resetEventLocation()
{

}
export function fetchingEvent()
{
	return {
		type: types.Event.FETCHING_EVENT
	}
}
export function fetchEvent(eventId) {
	return (dispatch,getState) =>
	{
		const userToken = getState().oidc.user.access_token
		const url = `${eventURL}/${eventId}`
		dispatch(fetchingEvent())
		getRequest(url,'json',userToken).then(resp => {
			dispatch(fetchEventSuccess(resp))
		})
	}	
}
export function fetchEventSuccess(event) {
	return {
		type: types.Event.FETCH_EVENT,
		payload:event
	}
}
export function fetchActiveSeasons(){
	const url = `${seasonURL}/active`
	const request = getRequest(url)
	return {
		type: types.Season.FETCH_ACTIVE_SEASONS,
		payload: request
	}
}
export function fetchCenter(searchby, searchvalue){
	let url = ''
	switch(searchby) {
		case types.Center.SEARCH_BY_NAME:{
			url = `${centerURL}?name=${searchvalue}&size=50`
			break
		}
		case types.Center.SEARCH_BY_NUMBER: {
			url = `${centerURL}/cert?number=${searchvalue}&size=50`
			break
		}
	}
	return (dispatch) =>
	{
		getRequest(url).then(resp => {
			dispatch(fetchCenterSuccess(resp.data.Results))
		})
	}	
}
export function fetchCenterSuccess(centers) {
	return {
		type: types.Center.FETCH_CENTER,
		payload:centers
	}
}
export function fetchMember(prefix,suffix) {
	return (dispatch, getState) =>
	{
		const url = `${memberURL}/${prefix}/${suffix}`
		const userToken = getState().oidc.user.access_token
		getRequest(url,'json',userToken).then(resp => {
			dispatch(fetchMemberSuccess(resp.data))
		})
	}
}
export function fetchMemberSuccess(member) {
	return {
		type: types.Event.FETCH_MEMBER,
		payload:member
	}
}
export function setDefaultEventSeason()
{
	return {
		type: types.Event.SET_DEFAULT_EVENT_SEASON,
	}
}
export function setEventType(eventtype) {
	return function()
	{
		return {
			type:  types.SET_EVENT_TYPE,
			payload: eventtype
		}
	}
}
export function saveEventInfo(info){
	return (dispatch,getState) =>
	{
		const url =  `${eventURL}/info`
		const userToken = getState().oidc.user.access_token
		postRequest(url,info,userToken).then(resp => {
			dispatch(saveEventInfoSuccess(resp.data))
		})
		.catch(function (err) {
			const { status, data } = err.response;
			const response = {
				status,
				data,
			}
			dispatch(saveEventInfoFailure(response));
		});
	}	
}
export function saveEventInfoSuccess(info) {
	return {
		type: types.Event.SAVE_EVENT_INFO,
		payload:info
	}
}
export function saveEventInfoFailure(errorInfo) {
	return {
		type: types.Event.SAVE_EVENT_INFO_ERROR,
		payload:errorInfo
	}
}
export function prestineNavigateNext() {
	return {
		type: types.Event.PRESTINE_NAVIGATE_NEXT,
	}
}
export function setDefaultWeeks(weeks) {
	return (dispatch) =>
	{
		dispatch(setDefaultWeeksSuccess(weeks));
	}	
}
export function setDefaultWeeksSuccess(weeks) {
	return {
		type: types.Event.SET_DEFAULT_WEEKS,
		payload:weeks,
	}
}
export function saveEventDetails(id,details) {
	return (dispatch,getState) =>
	{
		const url =   `${eventURL}/${id}/details`
		const user = getState().oidc.user;
		const userToken = user !== null ? user.access_token:'';
		postRequest(url,details,userToken).then(resp => {
			dispatch(saveEventDetailsSuccess(resp.data))
		})
		.catch(function (err) {
			let status;
			let data;

			if(err.response !== undefined)
			{
				status = err.response.status;
				data  = err.response.data;
			}
			else
			{
				status = 400;
				data = {
					ApplicationError:[err.Error]
				}
			}
			const response = {
				status,
				data,
			}
			dispatch(saveEventDetailsFailure(response));
		});
	}	
}
export function saveEventDetailsSuccess(details) {
	return {
		type: types.Event.SAVE_EVENT_DETAILS,
		payload:details
	}
}
export function saveEventDetailsFailure(errorInfo) {
	return {
		type: types.Event.SAVE_EVENT_DETAILS_ERROR,
		payload:errorInfo
	}
}
export function saveLaneConditionsInfo(id,conditions){
  return (dispatch, getState) => {
    dispatch(savingLaneConditions());
	
		const url = `${eventURL}/${id}/laneconditions`
		const userToken = getState().oidc.user.access_token
		postRequest(url,conditions,userToken).then(resp => {
			dispatch(saveLaneConditionsSuccess(resp.data));
		})
		.catch(function (err) {
			let status;
			let data;

			if(err.response !== undefined)
			{
				status = err.response.status;
				data  = err.response.data;
			}
			else
			{
				status = 400;
				data = {
					ApplicationError:[err.Error]
				}
			}
			const response = {
				status,
				data,
			}
			dispatch(saveLaneConditionsFailure(response));
		});
	}	
}
export function saveLaneConditionsFailure(errorInfo) {
	return {
		type: types.Event.SAVE_EVENT_OIL_CONDITIONS_ERROR,
		payload:errorInfo
	}
}
export function saveLaneConditionsSuccess(conditions) {
	return {
		type: types.Event.SAVE_EVENT_OIL_CONDITIONS,
		payload:conditions,
	};
}
export function savingLaneConditions() {
  return {
    type: types.Event.SAVING_EVENT_OIL_CONDITIONS,
  };
}
export function uploadingRulesFile() {
	return {
		type: types.Event.UPLOADING_RULES_FILE,
	};
}
export function uploadFileRules(rules){
	return (dispatch,getState) =>
	{
		const id= rules.get('eventId');
		const url = `${eventURL}/${id}/uploadrules`
		const userToken = getState().oidc.user.access_token
		postRequest(url,rules,userToken).then(resp => {
			dispatch(uploadRulesSuccess(resp.data));
		})
	}	
}
export function uploadRulesSuccess(rules) {
	return {
		type: types.Event.UPLOAD_RULES_FILE,
		payload:rules,
	};
}
export function rulesPendingApproval() {
	return {
		type: types.Event.RULES_PENDING_APPROVAL,
	};
}
export function saveEventSetup(id,setup){
	return (dispatch,getState) =>
	{
		const url = `${eventURL}/${id}/setup`
		const userToken = getState().oidc.user.access_token
		postRequest(url,setup,userToken).then(resp => {
			dispatch(saveEventSetupSuccess(resp.data));
    })
      .catch(function (err) {
        let status;
        let data;

        if (err.response !== undefined) {
          status = err.response.status;
          data = err.response.data;
        }
        else {
          status = 400;
          data = {
            ApplicationError: [err.Error]
          }
        }
        const response = {
          status,
          data,
        }
        dispatch(saveEventSetupFailure(response));
      });
	}	
}
export function saveEventSetupSuccess(setup) {
	return {
		type: types.Event.SAVE_EVENT_SETUP,
		payload:setup,
	};
}
export function saveEventSetupFailure(errorInfo) {
  return {
    type: types.Event.SAVE_EVENT_SETUP_ERROR,
    payload: errorInfo
  }
}
export function addMixedAgedDivision()
{
	return {
		type: types.Event.ADD_MIXED_AGE_DIVISION,
	}
}
export function resetDivisionsOffered()
{
	return {
		type: types.Event.RESET_DIVISIONS_OFFERED,
	}
}
export function deleteEventDivisionOffered(eventId, id) {
  return (dispatch, getState) => {
    const url = `${eventURL}/${eventId}/${id}/deletedivisionoffered`
    const userToken = getState().oidc.user.access_token
    postRequest(url, null, userToken).then(resp => {
      dispatch(deleteEventDivisionOfferedSuccess(resp.data))
    })
  }
}
export function deleteEventDivisionOfferedSuccess(resp) {
  return {
    type: types.Event.DELETE_EVENT_DIVISION_OFFERED,
    payload: resp,
  };
}

export function saveDeposit(id, deposit) {
  return (dispatch,getState) => {
    dispatch(savingEventDeposit());

    const url = `${eventURL}/${id}/deposit`
		const userToken = getState().oidc.user.access_token
		postRequest(url,deposit,userToken).then(resp => {
			dispatch(saveDepositSuccess(resp.data));
		})
		.catch(function (err) {
			let status;
			let data;

			if(err.response !== undefined)
			{
				status = err.response.status;
				data  = err.response.data;
			}
			else
			{
				status = 400;
				data = {
					ApplicationError:[err.Error]
				}
			}
			const response = {
				status,
				data,
			}
			dispatch(saveEventDepositFailure(response));
		});
	}	
}
export function saveEventDepositFailure(errorInfo) {
	return {
		type:types.Event.SAVE_EVENT_DEPOSIT_ERROR,
		payload:errorInfo
	}
}
export function saveDepositSuccess(deposit) {
	return {
		type: types.Event.SAVE_EVENT_DEPOSIT,
		payload:deposit,
	};
}
export function savingEventDeposit() {
	return {
		type: types.Event.SAVING_EVENT_DEPOSIT,
	};
}
export function deleteEvent(event) {
	return (dispatch,getState) =>
	{
		const url = `${eventURL}/${event.eventId}/delete`
		const userToken = getState().oidc.user.access_token
		postRequest(url,null,userToken).then(resp => {
			dispatch(deleteEventSuccess(resp))
		})
	}	
}
export function deleteEventSuccess(resp) {
	return {
		type: types.Event.DELETE_EVENT,
		payload:resp,
	}
}

export function cancelEvent(event) {
  return (dispatch, getState) => {
    const url = `${eventURL}/${event.eventId}/cancel`
    const userToken = getState().oidc.user.access_token
    postRequest(url, null, userToken).then(resp => {
      dispatch(cancelEventSuccess(resp))
    })
  }
}
export function cancelEventSuccess(resp) {
  return {
    type: types.Event.CANCEL_EVENT,
    payload: resp,
  }
}

export function copyEvent(event) {
	return (dispatch,getState) =>
	{
		const url = `${eventURL}/${event.eventId}/copy`
		const userToken = getState().oidc.user.access_token
		postRequest(url,null,userToken).then(resp => {
			dispatch(copyEventSuccess(resp))
		})
	}
}

export function copyEventSuccess(resp) {
	return {
		type: types.Event.COPY_EVENT,
		payload:resp,
	}
}

export function setOilRatio(elem,value)
{
	return {
		type: types.Event.SET_OIL_RATIO,
		payload: {
			elem,
			value,
		}
	};
}
export function initOilRatio(size)
{
	return {
		type: types.Event.INIT_OIL_RATIO,
		payload: {
			size,
		}
	};
}
export function addMixedAgeDivision()
{
	return {
		type: types.Event.ADD_MIXED_AGE_DIVISION,
	}
}

export function approveRules(eventId) {
	return (dispatch,getState) =>
	{
		const url = `${eventURL}/${eventId}/approveRules`
		const userToken = getState().oidc.user.access_token
		postRequest(url,null,userToken).then(resp => {
			dispatch(approveRulesSuccess(resp))
		})
	}	
}
export function approveRulesSuccess(resp) {
	return {
		type: types.Event.APPROVE_EVENT_RULES,
		payload:resp,
	}
}
export function denyRules(eventId) {
	return (dispatch,getState) =>
	{
		const url = `${eventURL}/${eventId}/denyRules`
		const userToken = getState().oidc.user.access_token
		postRequest(url,null,userToken).then(resp => {
			dispatch(denyRulesSuccess(resp))
		})
	}	
}
export function denyRulesSuccess(resp) {
	return {
		type: types.Event.DENY_EVENT_RULES,
		payload:resp,
	}
}
export function setUserRole(roleName) {	
	return {
		type: types.SET_USER_ROLE,
		payload: roleName
	}
}
export function setWizardStep(step) {	
	return {
		type: types.SET_WIZARD_STEP,
		payload: step
	}
}
export function fetchCompletedEvents() 
{
		
	const url = `${eventURL}/pendinguploads`
	const request = getRequest(url)
	return {
		type: types.FETCH_COMPLETED_EVENTS,
		payload: request
	}
}
export function resetEventRetrieved(){
	return {
		type: types.RESET_RETRIEVED_EVENT
   }
}
export function setCertificationNumber(certificationNumber,forceCertificationNumber){
	return {
		type: types.SET_CERTIFICATION_NUMBER,
		payload: {
			certificationNumber,
			forceCertificationNumber
		}
   }
}
export function uploadEventResults(eventId,certificationNumber,resultsFile)
{
	//const { eventId,certificationNumber } = resultsFile
	const url = `${eventURL}/${eventId}/${certificationNumber}/uploadresults`
	const request = axios.post(url,resultsFile,
		{ 
			crossdomain: true,
			headers: {
				'Access-Control-Allow-Origin' : '*',
				'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
				'content-type': 'multipart/form-data' 
			}
		}
	)
	return {
		type: types.fileUpload.UPLOAD_EVENT_RESULTS,
		payload: request
	}
}
export function setEventResultsFile(filename)
{
	return {
		type: types.fileUpload.SET_EVENT_RESULTS_FILENAME,
		payload: filename
   }
}
export function resetEventResultsFile()
{
	return {
		type: types.fileUpload.RESET_EVENT_RESULTS_FILE
   }
}
export function uploadingResultsFile()
{
	return {
		type: types.fileUpload.UPLOADING_RESULTS_FILE
   }
}
export function setWrongFileType()
{
	return {
		type: types.fileUpload.WRONG_FILE_UPLOAD_TYPE
   }
}
export function resetUploadErrorMessage()
{
	return {
		type: types.fileUpload.RESET_UPLOAD_ERROR_MESSAGE
   }
}

export function fetchingEvents()
{
	return {
		type: types.Event.FETCHING_EVENTS
	}
}

export function fetchEvents(seasonId, searchBy, searchValue){
	return (dispatch, getState) =>
	{
		const url = `${eventURL}/search/${searchBy}/${searchValue}/${seasonId}/`
		const userToken = getState().oidc.user.access_token
		getRequest(url,'json',userToken).then(resp => {
			dispatch(fetchEventsSuccess(resp.data))
		})
	}
}

export function fetchEventsSuccess(event) {
	return {
		type: types.Event.FETCH_EVENTS,
		payload:event
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/action_event.js